export default "__VITE_ASSET__7W$ST2zA__"